import { render, staticRenderFns } from "./PolaroidView.vue?vue&type=template&id=687093c0&scoped=true&"
import script from "./PolaroidView.vue?vue&type=script&lang=js&"
export * from "./PolaroidView.vue?vue&type=script&lang=js&"
import style0 from "./PolaroidView.vue?vue&type=style&index=0&id=687093c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687093c0",
  null
  
)

export default component.exports